import { xhr } from '@/api/config/Repository'
import ComboResponse from '@/services/models/comboCodeDescp/ComboResponse'
import ComboDTO from '../../dto/comboCodeDescp/ComboDTO'
import PenaltyMasterRepository from '../PenaltyMasterRepository'
import PenaltyResponse from '@/services/penaltyMaster/models/PenaltyResponse'
import PenaltyExportResponse from '@/services/penaltyMaster/models/PenaltyExportResponse'
import TablePenaltyRequest from '@/services/penaltyMaster/models/TablePenaltyRequest'
import TableExportRequest from '@/services/penaltyMaster/models/TableExportRequest'
import PenaltyResponseDTO from '../dto/PenaltyResponseDTO'
import DownloadPDTemplateResponseDTO from '@/services/penaltyMaster/models/DownloadPDTemplateResponse'
import QFNotificationRequest from '@/services/penaltyMaster/models/QFNotificationRequest'
import QFNotificationResponse from '@/services/penaltyMaster/models/QFNotificationResponse'
import TablePenaltyQFRequest from '@/services/penaltyMaster/models/TablePenaltyQFRequest'
export default class PenaltyMasterRepositoryImpl implements PenaltyMasterRepository {
  async getPenaltyStatusData (): Promise<ComboResponse> {
    const endpoint = 'md/getAllPenaltyStatus'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<ComboDTO[]>(endpoint, { headers })
    return {
      status: response.status,
      content: response.data
    }
  }

  async getExpectedActionData (): Promise<ComboResponse> {
    const endpoint = 'md/getAllExpectedAction'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<ComboDTO[]>(endpoint, { headers })
    return {
      status: response.status,
      content: response.data
    }
  }

  async getTablePenaltyData (paramData: TablePenaltyRequest, penaltyType: string): Promise<PenaltyResponse> {
    let reqBody: TablePenaltyRequest = {}
    let endpoint
    if (penaltyType === 'LogisticPenalty' || penaltyType === null) {
      reqBody = {
        pageNumber: paramData.pageNumber,
        pageSize: paramData.pageSize,
        sortBy: paramData.sortBy,
        country: paramData.country,
        supplier: paramData.supplier,
        warehouse: paramData.warehouse,
        penaltyID: paramData.penaltyID,
        anomalyType: paramData.anomalyType,
        penaltyAmount: paramData.penaltyAmount,
        startCreationDate: paramData.startCreationDate,
        endCreationDate: paramData.endCreationDate,
        startDeliveryDate: paramData.startDeliveryDate,
        endDeliveryDate: paramData.endDeliveryDate,
        penaltyStatus: paramData.penaltyStatus,
        expectedAction: paramData.expectedAction,
        sector: paramData.sector
      }
      endpoint = 'home/lp/fetchLPSummary'
    } else if (penaltyType === 'CashPenalty') {
      reqBody = {
        pageNumber: paramData.pageNumber,
        pageSize: paramData.pageSize,
        sortBy: paramData.sortBy,
        country: paramData.country,
        supplier: paramData.supplier,
        warehouse: paramData.warehouse,
        penaltyStatus: paramData.penaltyStatus,
        monthConcerned: paramData.monthConcerned,
        creationDate: paramData.creationDate,
        penaltyAmount: paramData.penaltyAmount,
        expectedAction: paramData.expectedAction,
        penaltyID: paramData.penaltyID
      }
      endpoint = 'home/cp/fetchCPSummary'
    } else if (penaltyType === 'ServicePenalties') {
      // endpoint = 'penaltySPTableData'
      reqBody = {
        pageNumber: paramData.pageNumber,
        pageSize: paramData.pageSize,
        sortBy: paramData.sortBy,
        country: paramData.country,
        supplier: paramData.supplier,
        warehouse: paramData.warehouse,
        penaltyStatus: paramData.penaltyStatus,
        startMonthConcerned: paramData.startMonthConcerned,
        endMonthConcerned: paramData.endMonthConcerned,
        startCreationDate: paramData.startCreationDate,
        endCreationDate: paramData.endCreationDate,
        monthConcerned: paramData.monthConcerned,
        creationDate: paramData.creationDate,
        penaltyAmount: paramData.penaltyAmount,
        expectedAction: paramData.expectedAction,
        penaltyId: paramData.penaltyID,
        qualifier: paramData.qualifier,
        isQf: false,
        sector: paramData.sector
      }
      endpoint = 'slp/fetchSLPSummary'
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<TablePenaltyRequest, PenaltyResponseDTO>(endpoint, reqBody, { headers })
    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async getTablePenaltyStatusData (paramData: TablePenaltyRequest): Promise<PenaltyResponse> {
    let reqBody: TablePenaltyRequest = {}
    let endpoint
    if (paramData.actionType === 'LogisticPenalty') {
      reqBody = {
        pageNumber: paramData.pageNumber,
        pageSize: paramData.pageSize,
        sortBy: paramData.sortBy,
        country: paramData.country,
        supplier: paramData.supplier,
        warehouse: paramData.warehouse,
        penaltyID: paramData.penaltyID,
        anomalyType: paramData.anomalyType,
        penaltyAmount: paramData.penaltyAmount,
        startCreationDate: paramData.startCreationDate,
        endCreationDate: paramData.endCreationDate,
        startDeliveryDate: paramData.startDeliveryDate,
        endDeliveryDate: paramData.endDeliveryDate,
        penaltyStatus: paramData.penaltyStatus,
        expectedAction: paramData.expectedAction
      }
      endpoint = 'home/lp/fetchQFHome'
    } else if (paramData.actionType === 'CashPenalty') {
      reqBody = {
        pageNumber: paramData.pageNumber,
        pageSize: paramData.pageSize,
        sortBy: paramData.sortBy,
        country: paramData.country,
        supplier: paramData.supplier,
        warehouse: paramData.warehouse,
        penaltyStatus: paramData.penaltyStatus,
        monthConcerned: paramData.monthConcerned,
        creationDate: paramData.creationDate,
        penaltyAmount: paramData.penaltyAmount,
        expectedAction: paramData.expectedAction,
        penaltyID: paramData.penaltyID
      }
      endpoint = 'home/cp/cpQFHome'
    } else {
      reqBody = {
        pageNumber: paramData.pageNumber,
        pageSize: paramData.pageSize,
        sortBy: paramData.sortBy,
        country: paramData.country,
        supplier: paramData.supplier,
        warehouse: paramData.warehouse,
        penaltyStatus: paramData.penaltyStatus,
        startMonthConcerned: paramData.startMonthConcerned,
        endMonthConcerned: paramData.endMonthConcerned,
        startCreationDate: paramData.startCreationDate,
        endCreationDate: paramData.endCreationDate,
        penaltyAmount: paramData.penaltyAmount,
        expectedAction: paramData.expectedAction,
        penaltyID: paramData.penaltyID,
        qualifier: paramData.qualifier,
        isQf: true,
        sector: paramData.sector
      }
      endpoint = 'slp/fetchSLPSummary'
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<TablePenaltyRequest, PenaltyResponseDTO>(endpoint, reqBody, { headers })
    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async getTablePenaltyStatusNewFeedbackQFData (paramData: TablePenaltyQFRequest): Promise<PenaltyResponse> {
    let reqBody: TablePenaltyQFRequest = {}
    const endpoint = 'notification/getNewFeedbackQf'
    reqBody = {
      pageNumber: paramData.pageNumber,
      pageSize: paramData.pageSize,
      sortBy: paramData.sortBy,
      isLpQf: paramData.isLpQf,
      isCpQf: paramData.isCpQf,
      isSlpQf: paramData.isSlpQf,
      isCreationTab: paramData.isCreationTab,
      countryId: paramData.countryId
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<TablePenaltyQFRequest, PenaltyResponseDTO>(endpoint, reqBody, { headers })
    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async downloadPDTemplate (): Promise<DownloadPDTemplateResponseDTO> {
    const endpoint = 'doc/downloadtemplate?template=LP_CREATE'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<any>(endpoint, { headers })
    return {
      stream: response.data.stream,
      extension: response.data.extension,
      status: response.status
    }
  }

  async getTableExportData (paramData: TableExportRequest, isQfFilter: boolean, penaltyType: string): Promise<PenaltyExportResponse> {
    let endpoint
    if (penaltyType === 'LogisticPenalty' || penaltyType === null) {
      endpoint = 'home/lp/export?isQfFilter=' + isQfFilter
    } else if (penaltyType === 'CashPenalty') {
      endpoint = 'home/cp/export?isQfFilter=' + isQfFilter
    } else if (penaltyType === 'ServicePenalties') {
      endpoint = 'slp/exportSlpSummary'
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<TableExportRequest, any>(endpoint, paramData, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getQFNotificationData (paramData: QFNotificationRequest): Promise<any> {
    const endpoint = 'notification/getQFNotification'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<QFNotificationRequest, QFNotificationResponse>(endpoint, paramData, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getCauseOfDisputeData (): Promise<any> {
    const endpoint = 'md/getCauseOfDispute'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<any>(endpoint, { headers })
    return {
      status: response.status,
      content: response.data
    }
  }
}
